/**
* Created by aresn on 16/7/4.
*/
/**
* 千位分隔符
* */
export default function (value) {
  return `${value}`.indexOf('.') > 0 ?
  `${value}`.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
   : `${value}`.replace(/\B(?=(\d{3})+$)/g, ',');
}
